import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { InternetPlans, PRODUCT_NAME } from "app/shared";
import { OnDestroyedDirective } from "app/shared/components/on-destroyed-component";
import { MuleCreateQuoteService } from "app/_core/services/mule-create-quote.service";
import {
	activatePUKSelector,
	MobileActivate,
	planMobileSelector,
	PlanState,
	setQuoteMobilePlan,
} from "app/_store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { WebApiService } from "_libs/web-api";

import { LocalStorageService } from "@dodo/local-storage";
import { LocalStorageKeys } from "app/_core/services/local-storage-state-restor.service";
import { SimStatusResponse } from "app/_core/_models/mobile/mobile.models";

@Injectable({
	providedIn: "root",
})
export class PlanSharedService extends OnDestroyedDirective {
	constructor(
		private webApi: WebApiService,
		private router: Router,
		private planStore: Store<PlanState>,
		private _muleCreateQuoteService: MuleCreateQuoteService,
		private activateStore: Store<MobileActivate>,
		private __localStorage: LocalStorageService
	) {
		super();
		// this.getQuoteState();
	}

	getProductOffering(product: string): Observable<any> {
		return this.webApi.get(
			`productCatalogMgmt/productOffering?product=${product}&groupBy=product&brand=dodo`,
			true,
			undefined,
			true
		);
	}

	getQuote(quoteId: string, quoteIdToken: string): Observable<any> {
		const url = "quoteMgmt/quote/" + quoteId;
		return this.webApi.getMS(url, { 'quoteidtoken': `${ quoteIdToken }` });
	}

	createQuote(
		product: string,
		productOfferId: string,
		simStatus?: SimStatusResponse,
		promoStacking?:string
	): Observable<any> {
		let body: any;
		body = {
			category: "Dodo",
			product: {
				id: productOfferId,
			}
		};
		if (simStatus) {
			const retailDist:any = {
				contextData: {
					cpqContextDataKey: {
						retailDistSimUpc: simStatus.product?.productCharacteristics?.find(
							(productCharacteristic) =>
								productCharacteristic?.name?.toLowerCase() === "upc"
						)?.value,
						retailDistSimStatus: simStatus.status,
						retailDistSimFaceValue: parseFloat(
							simStatus.remainingValue?.amount?.replace("$", "")
						),
						retailDistRetailerStoreID: simStatus.product?.productCharacteristics?.find(
							(productCharacteristic) =>
								productCharacteristic?.name?.toLowerCase() === "storeid"
						)?.value,
						retailDistRetailerName: simStatus.product?.productCharacteristics?.find(
							(productCharacteristic) =>
								productCharacteristic?.name?.toLowerCase() === "retailername"
						)?.value,
						retailDistRetailerActivationDate: simStatus.product?.productCharacteristics?.find(
							(productCharacteristic) =>
								productCharacteristic?.name?.toLowerCase() ===
								"activationdatetime"
						)?.value,
						retailDistExternalTransactionID: simStatus.relatedParty?.find(
							(party) => party?.name?.toLowerCase() === "transactionid"
						)?.value,
						retailDistExternalSerialNumber: simStatus.product?.productCharacteristics?.find(
							(productCharacteristic) =>
								productCharacteristic?.name?.toLowerCase() === "serialnumber"
						)?.value,
						planType: "RD_CH_PLANS_+_DIGI_PLANS",
					},
				},
			};

			if(promoStacking !== null && promoStacking !==""){
				retailDist["contextData"]["simPromoStackingBehaviour"] = promoStacking;
			}

			body = { ...body, ...retailDist };
		}
		return this.webApi.post(
			"quoteMgmt/quote?showNonSelectedProductCharacteristics=true",
			body,
			true,
			undefined,
			undefined,
			true
		);
	}
	updateQuote(quoteId: string, payload: any): Observable<any> {
		return this.webApi.put(
			`quoteMgmt/quote/${ quoteId }?showNonSelectedProductCharacteristics=true`,
			payload,
			undefined,
			true
		);
	}

	navToCheckout(): void {
		this.router.navigateByUrl("checkout/about-you");
	}

	updateMobileQuote(simNumber?: string, targetedPromo?: any): void {
		this.planStore
			.pipe(select(planMobileSelector), this.takeOne())
			.subscribe((state: any) => {
				const { quote, selectedPlan } = state;
				const currentSelections = [];
				let activePlan;

				console.log("quote shared service");
				console.log(quote);
				let quoteUi = quote?.ui ? quote.ui : quote?.items[0]?.ui;
				quoteUi
					?.filter(
						(ui) => ui?.type === "Mobile_Subscription_Specification"
					)
					.map((bP) => {
						let action;
						if (selectedPlan.elementGuid === bP.elementGuid) {
							action = "add";
							activePlan = bP;
						} else {
							action = "delete";
						}
						const mobileTmpObj = {
							elementGuid: bP.elementGuid,
							parentElementGuid: bP.parentElementGuid,
							action,
						};
						currentSelections.push(mobileTmpObj);
					});

				if (simNumber) {
					const quoteSim = quoteUi?.find((ui) => ui?.name === "SIM");
					if (quoteSim) {
						// Push SIM Details
						const simDetails = quoteSim.characterstic.filter(char => char.characteristicDescription === 'SIM Serial')[0];
						currentSelections.push({
							parentElementGuid: quoteSim.parentElementGuid,
							elementGuid: quoteSim.elementGuid,
							characteristics: [
								{
									action: "update",
									pattern: simDetails?.pattern,
									useArea: simDetails?.useArea,
									charactersticId:
										simDetails?.charactersticId,
									charValueId: simDetails?.characteristicCharValue[0].charValueId,
									value: simNumber,
								},
							],
							action: "update",
						});
						// Push PUK Details
						const pukDetails = quoteSim.characterstic.filter(char => char.characteristicDescription === 'PUK')[0];
						let pukNumber;
						this.activateStore
							.pipe(
								select(activatePUKSelector),
								this.distinctAndfilterNullAndUnsubscribe()
							)
							.subscribe((puk: string) => {
								pukNumber = puk;
							});
						currentSelections.push({
							parentElementGuid: quoteSim.parentElementGuid,
							elementGuid: quoteSim.elementGuid,
							characteristics: [
								{
									action: "update",
									pattern: pukDetails?.pattern,
									useArea: pukDetails?.useArea,
									charactersticId: pukDetails?.charactersticId,
									charValueId: pukDetails?.characteristicCharValue[0].charValueId,
									value: pukNumber,
								},
							],
							action: "update",
						});
					}
				}
				if (activePlan && activePlan.discounts && activePlan.discounts.length > 0 && selectedPlan.discount) {
					// add or delete third party promos

					const promoSelections = selectedPlan?.mobileTacticalOffers?.length
						? selectedPlan?.mobileTacticalOffers
						: [{
							grandParentElementGuid: selectedPlan.discount?.grandParentElementGuid,
							parentElementGuid: selectedPlan.discount?.parentElementGuid,
							elementGuid: selectedPlan.discount?.elementGuid,
						}];
					// const addPromo = {
					// 	grandParentElementGuid: selectedPlan.discount?.grandParentElementGuid,
					// 	parentElementGuid: selectedPlan.discount?.parentElementGuid,
					// 	elementGuid: selectedPlan.discount?.elementGuid,
					// 	action: "add",
					// };
					// // Mulesoft requirement to push the promo to the end which needs to be added
					// // Check if there is a promo to be added, as in case of targeted promo it would be empty
					// if (addPromo) {
					// 	currentSelections.push(addPromo);
					// }
					// Mulesoft requirement to push the promo to the end which needs to be added
					// Check if there is a promo to be added, as in case of targeted promo it would be empty
					promoSelections
					.filter((offer) => !!offer.elementGuid)
					.forEach((offer) => {
						const promo = {
							grandParentElementGuid: offer?.grandParentElementGuid,
							parentElementGuid: offer?.parentElementGuid,
							elementGuid: offer?.elementGuid,
						}
						currentSelections.push({ ...promo, action: "add" });
					});
				}
				console.log("currentSections => ", currentSelections)
				const { currentSelection, ...rest } = quote?.followedRequest ? quote?.followedRequest : quote?.items[0]?.followedRequest;
				const payload = { ...rest, currentSelections };				
				if (targetedPromo) {
					console.log(
						"in targeted promo",
						targetedPromo,
						payload,
						quote?.id
					);

					console.log(payload);

					this.updateQuote(quote?.id, payload).subscribe((quote$) => {
						this._muleCreateQuoteService
							.muleUpdateQuoteTargetedPromo(
								targetedPromo,
								quote$?.id,
								quote$?.followedRequest?.quoteItemId
							)
							.subscribe({
								next: (x) => {
									this.goToNextStep(x, simNumber);
								},
								error: (error) => {
									// Promo code already added
									if (
										error?.error?.error?.code === "400-11"
									) {
										this.navToCheckout();
									} else {
										console.log(error);
									}
								}
							});
					});
				} else {
					this.updateQuote(quote?.id, payload).subscribe((quote$) => {
						this.goToNextStep(quote$, simNumber);
					});
				}
			});
	}

	goToNextStep(quote: any, simNumber?: string) {
		this.planStore.dispatch(setQuoteMobilePlan({ quote }));
		if (simNumber) {
			this.navToCheckout();
		}
	}

	setQuoteState(quote): void {
		this.planStore.dispatch(setQuoteMobilePlan({ quote }));
	}
}
